<template>
	<div>
		<div v-if="displayDataEdit && !editMode">
			<b-container>
				<b-row> 
					<b-col class="img-col">
						<img v-if="displayDataEdit.imageUrl" :src="imageUrl" height="250px">
						<div v-if="!displayDataEdit.imageUrl" class="empty-image" />
					</b-col>
				</b-row>
				<b-row> 
					<b-col cols="10">
						<h4> {{ displayDataEdit.name }} </h4>
					</b-col>
					<b-col cols="2" style="text-align: right;">
						<b-button variant="link" @click="edit()">
							Edit
						</b-button>
					</b-col>
				</b-row>

				<b-row>
					<b-col style="height: 15px" />
				</b-row>

				<b-row>
					<b-col>
						<div> 
							<b> Tagline </b>
						</div>
						<div>
							{{ displayDataEdit.tagline || 'No tagline' }}
						</div>
					</b-col>
				</b-row>

				<b-row>
					<b-col style="height: 15px" />
				</b-row>

				<b-row>
					<b-col>
						<div> 
							<b> Description </b>
						</div>
						<div>
							{{ displayDataEdit.description || 'No description' }}
						</div>
					</b-col>
				</b-row>

				<b-row>
					<b-col style="height: 15px" />
				</b-row>

				<b-row>
					<b-col>
						<b> Links </b>
					</b-col>
				</b-row>
				<b-row v-for="(link, index) in displayDataEdit.link" :key="index">
					<b-col> 
						<b-icon icon="link45deg" />
						<a :href="formatLink(link.url)" target="_blank"> {{ link.name }} </a>
					</b-col>
				</b-row>
				<b-row v-if="!displayDataEdit.link || displayDataEdit.link.length === 0">
					<b-col> 
						No links
					</b-col>
				</b-row>

				<b-row>
					<b-col style="height: 15px" />
				</b-row>

				<b-row>
					<b-col>
						<div>
							<div> 
								<b> Year Built </b>
							</div>
							<div style="text-align: right">
								<hr style="border-top: 1px solid rgba(0, 0, 0); margin: 0px;">
								{{ displayDataEdit.yearBuilt || 'No built year information' }}
							</div>
						</div>
					</b-col>
					<b-col>
						<div>
							<div> 
								<b> Building Class </b>
							</div>
							<div>
								{{ displayDataEdit.buildingClass || 'No building class' }}
							</div>
						</div>
					</b-col>
				</b-row>

				<b-row>
					<b-col style="height: 15px" />
				</b-row>

				<b-row> 
					<b-col>
						<div> 
							<b> Zoning District </b>
						</div>
						<div>
							{{ displayDataEdit.zoningDistrict || 'No zoning district' }}
						</div>
					</b-col>
				</b-row>

				<b-row>
					<b-col style="height: 15px" />
				</b-row>

				<b-row>
					<b-col>
						<h5>Asset Location</h5>
					</b-col>
				</b-row>

				<b-row>
					<b-col style="height: 15px" />
				</b-row>

				<b-row> 
					<b-col>
						<div> 
							<b> Address </b>
						</div>
						<div>
							<pre>{{ address }}</pre>
						</div>
					</b-col>
				</b-row>

				<b-row>
					<b-col style="height: 15px" />
				</b-row>

				<b-row>
					<b-col>
						<h5>Positioning</h5>
					</b-col>
				</b-row>

				<b-row>
					<b-col style="height: 15px" />
				</b-row>

				<b-row>
					<b-col>
						<div>
							<div> 
								<b> Latitude </b>
							</div>
							<div style="text-align: right">
								<hr style="border-top: 1px solid rgba(0, 0, 0); margin: 0px;">
								{{ displayDataEdit.latitude || 'No latitude information' }}
							</div>
						</div>
					</b-col>
					<b-col>
						<div>
							<div> 
								<b> Longitude </b>
							</div>
							<div style="text-align: right">
								<hr style="border-top: 1px solid rgba(0, 0, 0); margin: 0px;">
								{{ displayDataEdit.longitude || 'No longitude information' }}
							</div>
						</div>
					</b-col>
				</b-row>

				<b-row>
					<b-col>
						<div>
							<div> 
								<b> Elevation </b>
							</div>
							<div style="text-align: right">
								<hr style="border-top: 1px solid rgba(0, 0, 0); margin: 0px;">
								{{ displayDataEdit.elevation || 'No elevation information' }}
							</div>
						</div>
					</b-col>
				</b-row>
			</b-container>
		</div>

		<div v-if="editMode">
			<b-container>
				<b-row> 
					<b-col cols="10" />
					<b-col cols="2" class="edit-button">
						<b-button variant="link" @click="edit()">
							Edit
						</b-button>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<label for="input-url">Image URL</label>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<image-upload-input :image-url="displayDataEdit.imageUrl" @update-image="updateImage" />
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<label for="input-name">Name</label>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<b-form-input
							id="input-name"
							v-model="displayDataEdit.name"
							size="sm"
							placeholder="Enter your name"
						/>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<label for="input-tagline">Tagline</label>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<b-form-input
							id="input-tagline"
							v-model="displayDataEdit.tagline"
							size="sm"
							placeholder="Enter the tagline"
						/>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<label for="input-description">Description</label>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<b-form-textarea
							id="input-description"
							v-model="displayDataEdit.description"
							size="sm"
							placeholder="Enter the description"
						/>
					</b-col>
				</b-row>
				
				<link-input
					v-for="(link, index) in displayDataEdit.link"
					:key="index"
					:link="link"
					:index="index"
					@update-link="updateLink"
					@remove-link="removeLink"
				/>

				<b-row v-if="!displayDataEdit.link || displayDataEdit.link.length === 0"> 
					<b-col>
						<label for="input-link">Link</label>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<b-button block @click="addLink()">
							Add a Link
						</b-button>
					</b-col>
				</b-row>

				<b-row> 
					<b-col>
						<label for="input-yearbuilt">Year Built</label>
					</b-col>
					<b-col>
						<label for="input-buildingclass">Building Class</label>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<b-form-input
							id="input-yearbuilt"
							v-model="displayDataEdit.yearBuilt"
							type="number"
							size="sm"
							placeholder="Enter year built"
						/>
					</b-col>
					<b-col>
						<b-form-input
							id="input-buildingclass"
							v-model="displayDataEdit.buildingClass"
							size="sm"
							placeholder="Enter building class"
						/>
					</b-col>
				</b-row>

				<b-row> 
					<b-col>
						<label for="input-zoningdistrict">Zoning District</label>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<b-form-input
							id="input-zoningdistrict"
							v-model="displayDataEdit.zoningDistrict"
							size="sm"
							placeholder="Enter the zoning district"
						/>
					</b-col>
				</b-row>

				<b-row>
					<b-col>
						<h5 style="margin-top: 0.5rem;">
							Asset Location
						</h5>
					</b-col>
				</b-row>

				<b-row>
					<b-col>
						<h5>Address</h5>
					</b-col>
				</b-row>

				<b-row> 
					<b-col>
						<label for="input-addressline1">Address Line 1</label>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<b-form-input
							id="input-addressline1"
							v-model="displayDataEdit.addressLine1"
							size="sm"
							placeholder="Enter the address"
						/>
					</b-col>
				</b-row>

				<b-row> 
					<b-col>
						<label for="input-addressline2">Address Line 2</label>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<b-form-input
							id="input-addressline2"
							v-model="displayDataEdit.addressLine2"
							size="sm"
							placeholder="Enter the address"
						/>
					</b-col>
				</b-row>

				<b-row> 
					<b-col>
						<label for="input-city">City</label>
					</b-col>
					<b-col>
						<label for="input-county">County</label>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<b-form-input
							id="input-city"
							v-model="displayDataEdit.city"
							size="sm"
							placeholder="Enter the city"
						/>
					</b-col>
					<b-col>
						<b-form-input
							id="input-county"
							v-model="displayDataEdit.county"
							size="sm"
							placeholder="Enter the county"
						/>
					</b-col>
				</b-row>

				<b-row> 
					<b-col>
						<label for="input-state">State</label>
					</b-col>
					<b-col>
						<label for="input-postalcode">Postal Code</label>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<b-form-input
							id="input-state"
							v-model="displayDataEdit.state"
							size="sm"
							placeholder="Enter the state"
						/>
					</b-col>
					<b-col>
						<b-form-input
							id="input-postalcode"
							v-model="displayDataEdit.postalCode"
							size="sm"
							placeholder="Enter the postal code"
						/>
					</b-col>
				</b-row>

				<b-row> 
					<b-col>
						<label for="input-country">Country</label>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<b-form-input
							id="input-country"
							v-model="displayDataEdit.country"
							size="sm"
							placeholder="Enter the country"
						/>
					</b-col>
				</b-row>

				<b-row>
					<b-col>
						<h5 style="margin-top: 0.5rem;">
							Positioning
						</h5>
					</b-col>
				</b-row>

				<b-row> 
					<b-col>
						<label for="input-latitude">Latitude (°)</label>
					</b-col>
					<b-col>
						<label for="input-longitude">Longitude (°)</label>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<b-form-input
							id="input-latitude"
							v-model="displayDataEdit.latitude"
							size="sm"
							type="number"
							placeholder="Enter the latitude"
						/>
					</b-col>
					<b-col>
						<b-form-input
							id="input-longitude"
							v-model="displayDataEdit.longitude"
							size="sm"
							type="number"
							placeholder="Enter the longitude"
						/>
					</b-col>
				</b-row>

				<b-row>
					<b-col>
						<label for="input-elevation">Elevation (ft.)</label>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<b-form-input
							id="input-elevation"
							v-model="displayDataEdit.elevation"
							size="sm"
							type="number"
							placeholder="Enter the elevation"
						/>
					</b-col>
				</b-row>
			</b-container>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import ImageUploadInput from './ImageUploadInput.vue';
import LinkInput from './LinkInput.vue';

export default {
	name: 'AssetProfile',
	components: {LinkInput, ImageUploadInput},
	props: {
	},
	data() {
		return {
			editMode: false,
			displayDataEdit: {},
			address: '',
			imageUrl: '',
			newLink: { name: '', url: '' }
		};
	},
	computed: {
		...mapState(['elementEditorEntityDataId']),
		formatLink () {
			return link => (link.indexOf("http") === -1 && link.indexOf("https") === -1 ) ? `https://${link}`: `${link}`
		}
	},
	watch: {
		elementEditorEntityDataId: {
			immediate: true,
			deep: true,
			handler() {
				this.getData();
			},
		},
		displayDataEdit: {
			deep: true,
			async handler() {
				if (this.displayDataEdit) {
				this.imageUrl = await this.getImage(this.displayDataEdit.imageUrl)
				this.address = this.formatAddress(this.displayDataEdit);
				}
				this.updateData();
			},
		},
		data: {
			immediate: true,
			handler(newVal) {
				this.displayDataEdit = newVal;
			},
		}
	},
	created() {
	},
	mounted() {
	},
	methods: {
		formatAddress(displayDataEdit) {
			let firstLine = ''; 
			let secondLine = '';
			let formatedAddress = '';
			// first line
			if (displayDataEdit.addressLine1 !== null && displayDataEdit.addressLine1 !== '') {
				firstLine = displayDataEdit.addressLine1
			}
			if (!displayDataEdit.addressLine2 !== null && displayDataEdit.addressLine2 !== '') {
				if (firstLine !== '') firstLine += ', '
				firstLine += displayDataEdit.addressLine2
			}
			// second line
			if (displayDataEdit.city !== null && displayDataEdit.city !== '') {
				secondLine = displayDataEdit.city
			}
			if (displayDataEdit.county !== null && displayDataEdit.county !== '') {
				if (secondLine !== '') secondLine += ', '
				secondLine += displayDataEdit.county
			}
			if (displayDataEdit.state !== null && displayDataEdit.state !== '') {
				if (secondLine !== '') secondLine += ', '
				secondLine += displayDataEdit.state
			}
			if (displayDataEdit.postalCode !== null && displayDataEdit.postalCode !== '') {
				if (secondLine !== '') secondLine += ', '
				secondLine += displayDataEdit.postalCode
			}
			// third line
			if (displayDataEdit.country === null || displayDataEdit.country === ''){
				if (firstLine !== '' && secondLine !== '') {
					formatedAddress = `${firstLine } \n`
					formatedAddress += `${secondLine }`
				} else if (firstLine !== '') {
					formatedAddress = `${firstLine }`
				} else if (secondLine !== '')  {
					formatedAddress = `${secondLine }`
				}
			} else if (firstLine !== '' && secondLine !== '') {
				formatedAddress = `${firstLine } \n`
				formatedAddress += `${secondLine } \n`
				formatedAddress += `${displayDataEdit.country }`
			} else if (firstLine !== '') {
				formatedAddress = `${firstLine } \n`
				formatedAddress += `${displayDataEdit.country }`
			} else if (secondLine !== '') {
				formatedAddress = `${secondLine } \n`
				formatedAddress += `${displayDataEdit.country }`
			} else {
				formatedAddress = displayDataEdit.country
			}
			if (formatedAddress === '') {
				formatedAddress = 'No address'
			}
			return formatedAddress;
		},
		async getData() {
			const assetprofileData = await this.axios.get(
				`/entities/${this.elementEditorEntityDataId}/assetprofiles`
			);
			if (assetprofileData.data.imageUrl) this.imageUrl = await this.getImage(assetprofileData.data.imageUrl)
			this.displayDataEdit = assetprofileData.data;
		},
		edit() {
			this.editMode = !this.editMode;
		},
		async updateData() {
			this.$czm('updateEntityData', this.elementEditorEntityDataId, {
				data: this.displayDataEdit,
			});
			if (this.displayDataEdit && this.displayDataEdit.id) {
				const postAssetProfileModelData = await this.axios.patch(
					`/assetprofiles/${this.displayDataEdit.id}`,
					this.displayDataEdit
				);
			}
		},
		addLink() {
			try {
				this.displayDataEdit.link.push(this.newLink);
				this.newLink = { name: '', url: '' };
			} catch (error) {
				this.$bvToast.toast(`${error.message}`, {
					title: `Bad Entry`,
					autoHideDelay: 5000,
					appendToast: false,
					variant: 'danger',
				});
			}
		},
		updateLink(data) {
			this.displayDataEdit.link[data.index] = data.link;
		},
		removeLink(index) {
			this.displayDataEdit.link.splice(index, 1);
		},
		async getImage(uri) {
			let image = '';
			if (uri.match(/^http.*/)) image = uri;
			if (uri.match(/^\/files\/*/)) {
				try {
					const img = await this.axios.get(`${uri}`, { responseType: 'blob' })
					image = URL.createObjectURL(img.data)
				} catch (error) {
					/* */
				}
				
			}			
			return image;
		},
		updateImage(data) {
			this.displayDataEdit.imageUrl = data;
		},
	},
};
</script>

<style>
.edit-button {
	float: right; 
	width: 100%; 
	text-align: right;
}
div.empty-image {
	height: 250px;
    border-radius: 12px;
	background-color: #d0d0d0;
}
.img-col {
	text-align: center; margin-bottom: 24px;
}
</style>
